export default __webpack_public_path__ + "static/media/samsung-saved-so-far.97d93f2e.png";